export default {
    created(){
        //this.$root.$root.picIsShow = true
    }
}